export function timespans() {
  return [
    { value: 'month', text: 'Last Month', disabled: false },
    { value: 'alltime', text: 'All Time (premium)', disabled: true }
  ]
}
